import axios from 'axios'
import promise from 'promise'
import ls from 'local-storage'
import jwtDecode from 'jwt-decode'
import { refreshToken } from '../data-store/actions/auth'
import store from '../data-store/store'
// Add a request interceptor
var axiosInstance = axios.create()

axiosInstance.interceptors.request.use((config) => {
  const s3Upload = /s3[.-]/.test(config.url) && /\.amazonaws\.com(:\d+)?(\/|$|\?|#)/.test(config.url)
  if (s3Upload) {
    config.headers['Content-Type'] = 'application/pdf'
  }
  const refreshingToken = (config.data && (typeof config.data === 'string') && config.data?.includes('grant_type') && config.data?.includes('refresh_token'))

  // Attaching token to headers for authentication on backend
  if (ls('token') && !s3Upload && !refreshingToken) {
    var token = ls('token')
    const tokenDecoded = jwtDecode(ls('token'))
    const expiry = tokenDecoded.exp
    const now = new Date()
    if (now.getTime() < expiry * 1000) {
      if (config.url.includes('package-scanned')) {
        config.headers.Authorization = `Bearer ${ls('fc_okta_token')}`
      }
      else if (config.method !== 'OPTIONS') {
        config.headers.Authorization = token
        config.headers['X-Content-Type-Options'] = 'nosniff'
      }
    } else {
      store.dispatch(refreshToken())
      const newToken = ls('token') // get the token again
      config.headers.Authorization = newToken // reassign the new token to the request
    }
  }
  return config
}, (error) => {
  return promise.reject(error)
})

export default axiosInstance
